import CookieStorage from './cookie'
import MemoryStorage from './memory'
import {
  canWriteStorage
} from '../helpers'

// We put 5000 characters so that the initial checker would be 5 KB of size
const Storage = canWriteStorage('a'.repeat(5000)) ? window.localStorage : navigator.cookieEnabled ? CookieStorage : MemoryStorage

export default Storage
